export const supportedChannels = [
    'facebookmessenger',
    'whatsapp',
    'sms',
    'email',
    'contactform',
    'widgetchat',
    'messenger',
    'twitter',
];
export function isChannelSupported(channel) {
    return supportedChannels.some((supportedChannel) => supportedChannel === channel);
}
export function isMessageSupported(message) {
    const conditions = [
        message.channel ? isChannelSupported(message.channel) : false,
        message.type === 'conversation:wrapup_message',
    ];
    return conditions.some((c) => c);
}
